import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { userLogin } from "../api";
import "../Auth.css";

function UserLogin() {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    rememberMe: false,
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await userLogin(formData);
      localStorage.setItem("token", res.data.token);
      navigate("/"); 
    } catch (err) {
      setError(err.response?.data?.message || "Login failed. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-wrapper">
        <div className="auth-visual">
          <h2>Welcome Back!</h2>
          <p>Sign in to your RepairMate account to track your requests and explore our premium services.</p>
        </div>

        <div className="auth-content">
          <div className="auth-form-header">
            <h1>Customer Login</h1>
            <p>Enter your details to access your account</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="auth-form-group">
              <label className="auth-label">Email Address</label>
              <div className="auth-input-wrapper">
                <i className="fas fa-envelope"></i>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="name@example.com"
                  required
                  className="auth-input"
                />
              </div>
            </div>

            <div className="auth-form-group">
              <label className="auth-label">Password</label>
              <div className="auth-input-wrapper">
                <i className="fas fa-lock"></i>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="••••••••"
                  required
                  className="auth-input"
                />
              </div>
            </div>

            <div className="auth-meta">
              <label className="auth-remember">
                <input
                  type="checkbox"
                  name="rememberMe"
                  checked={formData.rememberMe}
                  onChange={handleChange}
                />
                Remember me
              </label>
              <Link to="/forgot-password" title="Recover password" className="auth-link">
                Forgot password?
              </Link>
            </div>

            <button type="submit" disabled={loading} className="auth-submit-btn">
              {loading ? "Logging in..." : "Login to Account"}
            </button>
            
            {error && <div style={{color: '#dc3545', marginTop: '15px', textAlign: 'center', fontSize: '0.9rem'}}>{error}</div>}
          </form>

          <div className="auth-divider">
            <span>OR CONTINUE WITH</span>
          </div>

          <div className="auth-social">
            <button type="button" className="social-btn">
              <i className="fab fa-google" style={{color: '#DB4437'}}></i>
              Google
            </button>
            <button type="button" className="social-btn">
              <i className="fab fa-facebook-f" style={{color: '#4267B2'}}></i>
              Facebook
            </button>
          </div>

          <div className="auth-footer">
            Don't have an account? <Link to="/signup" className="auth-link">Sign up</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserLogin;